import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const CustomerData = loadable(() => import('./CustomerData'), {});
export const Import = loadable(() => import('./Import'), {});
export const Transport = loadable(() => import('./Transport'), {});
